import { Skeleton } from '@mui/material';
import '../WeatherDashboard.scss';
import './WeatherDashboardSkeleton.scss';
import { AgWidgetContainer } from 'app/agriculture/components/AgWidgetContainer/AgWidgetContainer';
import { AgWidget } from 'app/agriculture/components/AgWidget/AgWidget';
import { TopbarWidgetSkeleton } from '../TopBarWidget/TopbarWiddgetSkeleton/TopbarWidgetSkeleton';
import { SkeletonLineChart } from 'app/agriculture/charts/SkeletonLineChart/SkeletonLineChart';
import { SkeletonBarChart } from 'app/agriculture/charts/SkeletonBarChart/SkeletonBarChart';

export function WeatherDashboardSkeleton() {
    return (
        <div className={'WeatherDashboard WeatherDashboardSkeleton'}>
            <TopbarWidgetSkeleton />
            <AgWidgetContainer className="Dashboards" gridColumns={12} gridRows={12}>
                <AgWidget
                    className="WeatherDashboardSkeleton__table"
                    disablePadding
                    title={<Skeleton width={100} variant="text" />}
                    gridColumns={12}
                    gridRows={4}
                >
                    <div className="WeatherChartSkeleton__chart">
                        <Skeleton width={'100%'} />
                        <Skeleton width={'100%'} />
                        <Skeleton width={'100%'} />
                        <Skeleton width={'100%'} />
                        <Skeleton width={'100%'} />
                    </div>
                </AgWidget>

                <AgWidget
                    title={<Skeleton width={100} variant="text" />}
                    gridColumns={6}
                    gridRows={8}
                    Icon={() => <Skeleton width={20} />}
                >
                    <div className="WeatherChartSkeleton__chart">
                        <SkeletonBarChart />
                    </div>
                </AgWidget>

                <AgWidget
                    title={<Skeleton width={100} variant="text" />}
                    gridColumns={3}
                    gridRows={4}
                    Icon={() => <Skeleton width={20} />}
                >
                    <div className="WeatherChartSkeleton__chart">
                        <SkeletonLineChart />
                    </div>
                </AgWidget>

                <AgWidget
                    title={<Skeleton width={100} variant="text" />}
                    gridColumns={3}
                    gridRows={4}
                    Icon={() => <Skeleton width={20} />}
                >
                    <div className="WeatherChartSkeleton__chart">
                        <SkeletonLineChart />
                    </div>
                </AgWidget>
                <AgWidget
                    title={<Skeleton width={100} variant="text" />}
                    gridColumns={3}
                    gridRows={4}
                    Icon={() => <Skeleton width={20} />}
                >
                    <div className="WeatherChartSkeleton__chart">
                        <SkeletonLineChart />
                    </div>
                </AgWidget>
                <AgWidget
                    title={<Skeleton width={100} variant="text" />}
                    gridColumns={3}
                    gridRows={4}
                    Icon={() => <Skeleton width={20} />}
                >
                    <div className="WeatherChartSkeleton__chart">
                        <SkeletonLineChart />
                    </div>
                </AgWidget>
            </AgWidgetContainer>
        </div>
    );
}
